/* ALTAS Pro – 対応機種チェッカーと数量ボタン */
(function () {
  function initChecker(root) {
    if (root.dataset.altasReady) return;
    root.dataset.altasReady = '1';
    var buttons = root.querySelectorAll('[data-maker]');
    var nameEl = root.querySelector('[data-result-name]');
    var swEl = root.querySelector('[data-result-sw]');
    var modelEl = root.querySelector('[data-result-model]');
    var dips = root.querySelectorAll('[data-dip]');

    function select(btn) {
      buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      var sw = btn.dataset.sw;
      if (nameEl) nameEl.textContent = btn.dataset.name;
      if (swEl) swEl.textContent = 'SW' + sw;
      if (modelEl) modelEl.textContent = btn.dataset.model || '—';
      dips.forEach(function (d) { d.classList.toggle('is-on', d.dataset.dip === sw); });
    }
    buttons.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
    if (buttons[0]) select(buttons[0]);
  }

  function initQty(root) {
    if (root.dataset.altasReady) return;
    root.dataset.altasReady = '1';
    var input = root.querySelector('input');
    root.querySelectorAll('[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v + parseInt(btn.dataset.step, 10));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-altas-checker]').forEach(initChecker);
    (scope || document).querySelectorAll('[data-altas-qty]').forEach(initQty);
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  /* テーマエディタでセクションを追加・変更したときも動くように */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
